var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":"","dark":"","inset":"","padless":""}},[_c('v-card',{staticClass:"flex",attrs:{"flat":"","tile":""}},[_c('v-card-text',{staticClass:"py-1 white--text text-right"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }